/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author    Afternet <info@afternet.gr>
 * @copyright 2023 Afternet
 * @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

export default function manufacturerSlider(){
    if($('.js-manufacturerSlider').length ){
        const swiper = new Swiper(".js-manufacturerSlider", {
            slidesPerView: "auto",
            freeMode: true,
            spaceBetween: 10,
            lazy: {
                loadedClass: 'loaded',
                checkInView: true,
            },
            watchOverflow: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            navigation: {
                nextEl: '.js-manufacturerSlider-next',
                prevEl: '.js-manufacturerSlider-prev'
            }
        });
    }
}